import { Suspense } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import { GlobalStyles } from "./styles/GlobalStyles";
import { token } from "./theme";
import { WindowManagerProvider } from "./pages/HomePage/utils/WindowManager";

function App() {
  return (
    <BrowserRouter>
      <WindowManagerProvider>
        <GlobalStyles theme={token} />
        <Suspense>
          <Routes>
            <Route path="/*" element={<HomePage />} />
            <Route path="/login" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
          </Routes>
        </Suspense>
      </WindowManagerProvider>
    </BrowserRouter>
  );
}

export default App;
